import { useMutation } from "@tanstack/react-query";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/base";
import { captureException } from "@/services/log";

interface ImproveIdeaDescriptionRequest {
  titulo: string;
  descricao: string;
}

interface ImproveIdeaDescriptionResponse {
  suggestion: string;
  orientacoes: string[];
}

/**
 * Hook to request an AI-improved idea description.
 * @returns Mutation for generating the suggestion and guidance tips
 */
export function useImproveIdeaDescription() {
  const improveIdeaDescriptionFunction = httpsCallable<ImproveIdeaDescriptionRequest, ImproveIdeaDescriptionResponse>(
    functions,
    "ideiasFunctions-improveIdeaDescription"
  );

  return useMutation({
    mutationFn: async (parameters: ImproveIdeaDescriptionRequest) => {
      try {
        const result = await improveIdeaDescriptionFunction(parameters);
        return result.data;
      } catch (error) {
        console.error("[useImproveIdeaDescription] Erro na chamada:", error);
        captureException(error as Error, true);
        throw error;
      }
    }
  });
}
